export interface ParsedInsuranceAddress {
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}

export interface InsuranceCompanyNames {
  shortName?: string;
  longName?: string;
}

export interface ParsedInsuranceData {
  bin?: string;
  pcn?: string;
  groupId?: string;
  cardholderId?: string;
  pbm?: string;
  insuranceCompanyName?: InsuranceCompanyNames;
  patientName?: string;
  claimAddress?: ParsedInsuranceAddress;
  isMedicaid: boolean;
  isMedicare: boolean;
}

// Provider Type enum values (must match backend Plan.ProviderType)
export enum ProviderType {
  Unknown = 0,
  Medicare = 1,
  Medicaid = 2,
  Commercial = 3,
  Coupon = 4,
  TriCare = 5,
  ChampVa = 6,
  Government = 7,
  WorkmanComp = 8,
  Medical = 9
}

/**
 * Derives the provider type based on Medicare/Medicaid flags
 * @param isMedicaid - Whether the insurance is Medicaid
 * @param isMedicare - Whether the insurance is Medicare
 * @returns ProviderType enum value
 */
export function deriveProviderType(isMedicaid: boolean, isMedicare: boolean): ProviderType {
  if (isMedicaid) {
    return ProviderType.Medicaid;
  }
  if (isMedicare) {
    return ProviderType.Medicare;
  }
  return ProviderType.Commercial; // Default to Commercial
}

/**
 * Gets the display name from parsed insurance company names
 * Prefers short name over long name
 */
export function getInsuranceDisplayName(insuranceCompanyName?: InsuranceCompanyNames): string {
  if (!insuranceCompanyName) return '';
  return insuranceCompanyName.shortName || insuranceCompanyName.longName || '';
}
